// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-success {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.success-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #ecfdf5;
  border: 2px solid #0d9488;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.success-icon {
  width: 40px;
  height: 40px;
  color: #0d9488;
  margin-bottom: 0.5rem;
}

.success-text {
  font-size: 1rem;
  color: #0d9488;
}

.success-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #111827;
  margin: 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/uploadAndRecording/UploadSuccess.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX","sourcesContent":[".upload-success {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.success-circle {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background-color: #ecfdf5;\n  border: 2px solid #0d9488;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.success-icon {\n  width: 40px;\n  height: 40px;\n  color: #0d9488;\n  margin-bottom: 0.5rem;\n}\n\n.success-text {\n  font-size: 1rem;\n  color: #0d9488;\n}\n\n.success-title {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #111827;\n  margin: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
